import React, { useState } from "react";
import "../../../styles/General.css";
import { formatCurrency } from "../../../utils/format";
import ProjectStatsCard, { getCarValues } from "./ProjectStatsCard";
import BudgetSummary from "./BudgetSummary";

function General({ data }) {
  const budgets = data?.budget_data || {};

  return (
    <div className="fs-6">
      <div className="row">
        <div className="row">
          {data?.stat &&
            Object.keys(data?.stat).map((key) => {
              return (
                <ProjectStatsCard
                  keyValue={key}
                  title={getCarValues(key, data?.stat).title}
                  icon={getCarValues(key, data?.stat).icon}
                  iconClass={getCarValues(key, data?.stat).iconClass}
                  total={getCarValues(key, data?.stat).total}
                  rows={getCarValues(key, data?.stat).rows || []}
                  progress={getCarValues(key, data?.stat).progress}
                  statusText={getCarValues(key, data?.stat).statusText}
                  formatCurrency={formatCurrency}
                />
              );
            })}
        </div>

        {/* Budget Utilization Card */}
        <BudgetSummary budgets={budgets} />
      </div>
    </div>
  );
}

export default General;
